<template>
	<div>
		<!-- main content -->
		<div class="container-loading" v-if="isFetching">
			<div class="is-loading large"></div>
		</div>
		<div
			v-if="!isFetching"
			class="">
			<div class="flex-center">
				<div class="flex-center-left">
					<div class="mr-2">
						<div @click="changeStatus('all')" class="filter-calendar flex-center-left pointer"
						:class="{'filter-calendar-active': filterStatus === 'all'}"><div class="status-dot-all mr-2"></div>{{ $t('All') }}</div>
					</div>
					<div class="flex-center-left mr-2 ml-4">
						<div @click="changeStatus('pre_production')" class="filter-calendar flex-center-left pointer"
						:class="{'filter-calendar-active': filterStatus === 'pre_production'}"><div class="status-dot-pre_production mr-2"></div>{{ $t('Pre Production') }}</div>
					</div>
					<div class="flex-center-left mr-2 ml-4">
						<div @click="changeStatus('production')" class="filter-calendar flex-center-left pointer"
						:class="{'filter-calendar-active': filterStatus === 'production'}"><div class="status-dot-production mr-2"></div>{{ $t('Production') }}</div>
					</div>
					<div class="flex-center-left mr-2 ml-4">
						<div @click="changeStatus('post_production')" class="filter-calendar flex-center-left pointer"
						:class="{'filter-calendar-active': filterStatus === 'post_production'}"><div class="status-dot-post_production mr-2"></div>{{ $t('Post Production') }}</div>
					</div>
					<div class="flex-center-left mr-2 ml-4">
						<div @click="changeStatus('archive')" class="filter-calendar flex-center-left pointer"
						:class="{'filter-calendar-active': filterStatus === 'archive'}"><div class="status-dot-archive mr-2"></div>{{ $t('Archive') }}</div>
					</div>
				</div>
				<div class="relative">
					<i class="material-icons wrapper-search-input ml-2">search</i>
					<input
						type="text"
						class="form-control search-input"
						:placeholder="$t('Search Rundown')"
						@input="onKeywordChange"
						v-model="keyword"
					/>
				</div>
			</div>
			<div class="mt-6">
				<vue-cal
					:selected-date="selectedDate"
					:time-from="7 * 60"
					:time-to="24 * 60"
					:disable-views="['years']"
					:active-view="activeView"
					events-on-month-view="short"
					:events="items"
					@ready="calReady($event)"
					@view-change="logEvents($event)"
					@cell-click="onDayClick"
					:on-event-click="onEventClick"
					today-button
					style="height: 100%">
				</vue-cal>
			</div>
			<modal
				@close="isShowModalDetail = false"
				size="medium"
				v-if="isShowModalDetail"
				:hideFooter="true">
				<template slot="header">
					<h3>{{ $t('Date Details') }}</h3>
				</template>
				<template slot="body">
					<h3 class="text-white">{{ modalDay }}</h3>
					<div class="container-day-detail">
						<div v-for="event in modalDetailEvent" :key="event.id">
							<div @mouseover="itemHover(event)" @mouseleave="itemLeave(event)" @mousemove="updateTooltipPosition" class="pointer relative" :class="`day-event-detail-${event.status}`">
								<div class="title">{{ event && event.additional && event.additional.name }}</div>
								<div class="mt-3">{{ event && event.start && event.start ? getDateUtc(event.start) : ''  }}</div>
								<div>
									{{ event && event.additional && event.additional.__meta__ &&
									event.additional.__meta__.rundownItems_count &&
									event.additional.__meta__.rundownItems_count > 0 ? `${event.additional.__meta__.rundownItems_count} Assets` : '0 Asset' }}
									{{ event && event.additional && event.additional.active_users && activeUsers(event.additional.active_users) > 0 ? `| ${activeUsers(event.additional.active_users)} Active Users` : '' }}
								</div>
								<div class="icon-detail-day d-flex" v-if="hoverItem === event.id">
									<button
										class="btn btn-default btn-icon mr-2"
										@click="goToRundown(event.additional)">
										<i class="material-icons md-18">visibility</i>
									</button>
									<button
										class="btn btn-default btn-icon mr-2"
										:class="{ 'is-loading': isSharing }"
										@click="sharingMisc(event.additional.id)">
										<i class="material-icons md-18">folder</i>
									</button>
									<button
										class="btn btn-default btn-icon mr-2"
										@click="confirmEdit(event.additional)">
										<i class="material-icons md-18">edit</i>
									</button>
									<button
										class="btn btn-danger btn-icon"
										@click="confirmRemoveItem(event.additional)">
										<i class="material-icons md-18">delete</i>
									</button>
								</div>
								<div v-if="isTooltipVisible && tooltipContent" class="tooltip-misc" :style="{ top: `${tooltipPosition.y}px`, left: `${tooltipPosition.x}px` }">
									{{ tooltipContent }}
								</div>
							</div>
						</div>
					</div>
				</template>
			</modal>

			<!-- Delete Confirmation -->
			<modal
				size="small"
				@close="isConfirmRemoveVisible = false"
				v-if="isConfirmRemoveVisible">
				<template slot="header">
					{{ $t('Confirm Delete') }}
				</template>
				<template slot="body">
					<div class="text-white" v-if="selectedTotalAsset > 0">{{ $t(`There are ${selectedTotalAsset} assets in this rundown`) }}</div>
					<div>{{ $t('Are you sure want to delete') }} {{ showModalName(selectedRundown ? selectedRundown.name : '-') }}?</div>
				</template>
				<template slot="footer">
					<div class="w-100 flex-center" :class="{'mt-4': selectedTotalAsset > 0}">
						<button class="btn btn-primary" :class="{ 'is-loading': isRemoving }" @click="removeItem(selectedRundown)">
							{{ $t('Yes, Delete It') }}
						</button>
						<button class="btn btn-default" @click="isConfirmRemoveVisible = false">
							{{ $t('Cancel') }}
						</button>
					</div>
				</template>
			</modal>

			<!-- Edit Rundown -->
			<modal
				size="small-medium"
				@close="isEditVisible = false"
				v-if="isEditVisible"
				>
				<template slot="header">
					{{ $t('Edit Rundown') }}
				</template>
				<template slot="body">
					<div class="form-group mb-3">
						<!-- name -->
						<label class="text-primary">{{ $t('Rundown Name') }}</label>
						<input
							type="text"
							class="form-control mb-4"
							v-model="rundownName"
						/>
						<!-- date time -->
						<div class="d-flex">
							<div style="width: 100%">
								<label class="text-primary">{{ $t('Date & Time') }}</label>
								<date-picker
									:lang="lang"
									v-model="dateTime"
									type="datetime"
									placeholder="Select datetime"
									:minute-step="30"
									:default-value="new Date().setHours(9, 0, 0, 0)"
									:disabled-date="notBeforeToday"
									format="DD/MM/YYYY HH:mm"
									valueType="YYYY-MM-DD HH:mm"
									:show-time-panel="showTimePanel"
									@close="handleOpenChange"
								>
									<template v-slot:footer>
									<button class="mx-btn mx-btn-text" @click="toggleTimePanel">
										{{ showTimePanel ? 'select date' : 'select time' }}
									</button>
									</template>
								</date-picker>
							</div>
							<div class="form-group select ml-2" style="width: 100%; max-height: 20px;">
								<label class="text-primary">Status</label>
								<div class="mh-40px">
									<multiselect class="select-input" v-model="status" deselect-label="Can't remove this value" track-by="label" label="label"
										placeholder=" " :options="filteredStatusList" :searchable="true" :allow-empty="false" :show-labels="false">
										<template slot="singleLabel" slot-scope="props">
											<div class="flex-center-left">
												<div :class="`status-dot-${props.option.key || 'pre_production'}`" class="mr-2"></div>
												<div class="option__desc">{{ props.option.label ? props.option.label : 'Pre Production' }}</div>
											</div>
										</template>
										<template slot="option" slot-scope="props">
											<div class="flex-center-left">
												<div :class="`status-dot-${props.option.key}`" class="mr-2"></div>
												<div class="option__desc">{{ props.option.label }}</div>
											</div>
										</template>
										<span class="arrow-multiselect" slot="caret">
											<i class="material-icons pb-1 mt-1 ml-2 size-arrow">expand_more</i>
										</span>
										<span slot="noResult">Oops! No package found.</span>
									</multiselect>
								</div>
							</div>
						</div>
						<!-- note -->
						<label class="text-primary mt-3">{{ $t('Notes') }}</label>
						<textarea type="text" name="note" rows="6" class="form-control" maxlength="455"
							v-model="description">
						</textarea>
					</div>
				</template>
				<template slot="footer">
					<button
						type="button"
						class="btn btn-primary"
						:class="{ 'is-loading': isSavingRundown }"
						:disabled="!rundownName || !dateTime"
						@click="updateRundown(selectedRundown)">
						{{ $t('Save') }}
					</button>
					<button
						type="button"
						class="btn btn-default"
						@click="isEditVisible = false">
						{{ $t('Cancel') }}
					</button>
				</template>
			</modal>

			<!-- Shared folder Confirmation -->
			<modal
					size="small"
					@close="isConfirmSharedFolderVisible = false"
					v-if="isConfirmSharedFolderVisible">
					<template slot="header">
						{{ $t('Confirm Share Folder') }}
					</template>
					<template slot="body">
						<div>{{ $t('Are you sure want to share') }} {{ showModalName(selectedRundown ? selectedRundown.name : '-') }} {{ $t('folder') }}?</div>
					</template>
					<template slot="footer">
						<div class="w-100 flex-center" :class="{'mt-4': selectedTotalAsset > 0}">
							<button class="btn btn-primary" :class="{ 'is-loading': isSharing }" @click="sharingMisc(selectedRundown)">
								{{ $t('Yes') }}
							</button>
							<button class="btn btn-default" @click="isConfirmSharedFolderVisible = false">
								{{ $t('Cancel') }}
							</button>
						</div>
					</template>
				</modal>
		</div>
	</div>
</template>

<script>
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import dayjs from 'dayjs';
import rundownsApi from '@/api/rundowns';
import Modal from '@/components/Modal.vue';
import Multiselect from 'vue-multiselect';
import DatePicker from 'vue2-datepicker';
import mediasApi from '@/api/medias';

import 'vue2-datepicker/index.css';
import utc from 'dayjs/plugin/utc';
import { EventBus } from '@/lib/event-bus';
import {
	delay, getAxiosErrorMessage, elpisisString, duplicateVar, copyToClipboard,
} from '@/lib/helper';

dayjs.extend(utc);

export default {
	name: 'CalendarView',
	components: {
		VueCal,
		Modal,
		Multiselect,
		DatePicker,
	},
	props: {
	},
	data() {
		return {
			currentPage: 1,
			totalPage: 1,
			totalItems: 0,
			orderBy: 'created_at',
			sortBy: 'desc',
			limit: 1000,
			items: [],
			isFetching: false,
			selectedDate: '',
			months: `[${dayjs(new Date()).format('MM')}]`,
			years: dayjs(new Date()).format('YYYY'),
			activeView: 'month',
			filterStatus: 'all',
			keyword: '',
			selectedDay: null,
			isShowModalDetail: false,
			modalDetailEvent: [],
			modalDay: null,

			// hover
			hover: false,
			hoverItem: null,

			selectedRundown: null,
			// delete rundown
			isConfirmRemoveVisible: false,
			isRemoving: false,

			// edit rundown
			isEditVisible: false,
			isSavingRundown: false,
			rundownName: '',
			description: '',
			status: '',
			dateTime: '',
			lang: {
				formatLocale: {
					firstDayOfWeek: 1,
				},
			},

			// filterstatus
			statusList: [
				{ key: 'all', label: 'All' },
				{ key: 'pre_production', label: 'Pre Production' },
				{ key: 'production', label: 'Production' },
				{ key: 'post_production', label: 'Post Production' },
				{ key: 'archive', label: 'Archive' },
			],

			// date picker
			showTimePanel: false,

			// sharing misc
			isConfirmSharedFolderVisible: false,
			isSharing: false,

			// tooltip
			isTooltipVisible: false,
			tooltipPosition: { x: 0, y: 0 },
			tooltipContent: null,
		};
	},
	created() {
		EventBus.$on('call-method-in-calendar-view', this.fetchListCalendarView);
	},
	mounted() {
		this.fetchListCalendarView();
	},
	beforeUnmount() {},
	methods: {
		toggleTimePanel() {
			this.showTimePanel = !this.showTimePanel;
			setTimeout(() => {
				const headline = document.getElementsByClassName('mx-time-header-title');
				headline[0].innerText = dayjs(headline[0].innerText).format('DD/MM/YYYY');
			}, 100);
		},
		handleOpenChange() {
			this.showTimePanel = false;
		},
		itemLeave() {
			this.hover = false;
			this.hoverItem = null;
			this.isTooltipVisible = false;
			this.tooltipContent = null;
		},
		itemHover(item) {
			this.tooltipContent = item && item.additional && item.additional.description ? item.additional.description : '';
			delay(() => {
				this.isTooltipVisible = true;
			}, 1000);
			this.hover = true;
			this.hoverItem = item.id;
		},
		updateTooltipPosition(event) {
			this.tooltipPosition = { x: event.pageX, y: event.pageY + 28 }; // Adjust 28px for spacing
		},
		activeUsers(activeUser) {
			const parsedActiveUser = activeUser;
			const parseUser = JSON.parse(parsedActiveUser);
			return parseUser.length;
		},
		calReady(e) {
			const year = dayjs(e.startDate).format('YYYY');
			const startMonth = dayjs(e.startDate).format('M');
			const endMonth = dayjs(e.endDate).format('M');
			this.years = year;
			this.months = [];
			if (startMonth === endMonth) this.months = `[${startMonth}]`;
			if (startMonth !== endMonth) {
				this.months = [];
				this.months.push(startMonth);
				this.months.push(endMonth);
				this.months = JSON.stringify(this.months);
			}
			if (e.events.length > 0) {
				this.selectedDate = e.events[e.events.length - 1].start;
			} else if (e.events.length === 0) {
				this.selectedDate = e.startDate;
			}
		},
		logEvents(e) {
			const year = dayjs(e.startDate).format('YYYY');
			const startMonth = dayjs(e.startDate).format('M');
			const endMonth = dayjs(e.endDate).format('M');
			this.years = year;
			this.months = [];
			if (startMonth === endMonth) this.months = `[${startMonth}]`;
			if (startMonth !== endMonth) {
				this.months = [];
				this.months.push(startMonth);
				this.months.push(endMonth);
				this.months = JSON.stringify(this.months);
			}
			if (e.events.length > 0) {
				this.selectedDate = e.events[e.events.length - 1].start;
			} else if (e.events.length === 0) {
				this.selectedDate = e.startDate;
			}
			this.fetchListCalendarView(e.view);
		},
		onEventClick(event) {
			const newDate = (event.start).format('YYYY-MM-DD');
			const items = this.items.filter(item => item.start.includes(newDate));
			if (items && items.length > 0) {
				this.isShowModalDetail = true;
				this.modalDetailEvent = items;
				this.modalDay = dayjs.utc(event.start).format('dddd, DD MMMM YYYY');
			}
		},
		onDayClick(event) {
			const newDate = dayjs.utc(event).format('YYYY-MM-DD');
			const items = this.items.filter(item => item.start.includes(newDate));
			if (items && items.length > 0) {
				this.isShowModalDetail = true;
				this.modalDetailEvent = items;
				this.modalDay = dayjs.utc(event).format('dddd, DD MMMM YYYY');
			}
		},
		onKeywordChange() {
			this.filterStatus = 'all';
			delay(() => {
				// this.fetch(true);
				this.fetchListCalendarView('month');
			}, 500);
		},
		changeStatus(status) {
			this.filterStatus = status;
			this.fetchListCalendarView('month');
		},
		fetchListCalendarView(view) {
			if (view) this.activeView = view;
			this.isFetching = true;
			const params = {
				order_by: this.orderBy,
				sort_by: this.sortBy,
				limit: this.limit,
				page: this.currentPage,
				years: this.years,
				months: this.months,
				status: this.filterStatus,
			};
			if (this.keyword) params.keyword = this.keyword;
			const callback = (response) => {
				const data = response.data;
				this.totalPage = response.last_page;
				this.totalItems = response.total;
				this.items = [];
				for (let index = 0; index < data.length; index++) {
					const rundown = data[index];
					if (rundown && rundown.start_time) {
						const startHour = dayjs.utc(rundown.start_time).format('HH:mm');
						const dateTime = dayjs.utc(rundown.start_time).format('YYYY-MM-DD');
						const newEndTime = dayjs.utc(rundown.start_time).add(1, 'hour').format('HH:mm');
						const rundownResult = {
							start: `${dateTime} ${startHour}`,
							end: `${dateTime} ${newEndTime}`,
							// message: element.message,
							title: `<div style="font-size: 13px; font-weight: 400; max-width: 200px; white-space: nowrap; overflow: hidden; overflow: hidden; text-overflow: ellipsis;"> ${rundown.name} </div>`,
							id: rundown.id,
							additional: rundown,
							status: rundown.status,
						};
						if (rundown.status === 'pre_production') rundownResult.class = 'event-pre_production';
						if (rundown.status === 'production') rundownResult.class = 'event-production';
						if (rundown.status === 'post_production') rundownResult.class = 'event-post_production';
						if (rundown.status === 'archive') rundownResult.class = 'event-archive';
						this.items.push(rundownResult);
					}
				}
				if (view === 'month' && this.items.length > 0) {
					this.selectedDate = this.items[this.items.length - 1].start;
				}
				this.isFetching = false;
			};
			const errorCallback = (error) => {
				const message = error.response.data.message;
				this.__showNotif('error', 'Error', message);
				this.isFetching = false;
			};
			rundownsApi.getList(params, callback, errorCallback);
		},

		confirmRemoveItem(item) {
			this.selectedRundown = item;
			this.isConfirmRemoveVisible = true;
		},

		removeItem(item) {
			this.isRemoving = true;
			const callback = (response) => {
				const message = response.message;
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.items.splice(index, 1);
				}
				const indexDayDetail = this.modalDetailEvent.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					this.modalDetailEvent.splice(indexDayDetail, 1);
				}

				if (this.modalDetailEvent && this.modalDetailEvent.length === 0) this.isShowModalDetail = false;
				this.isRemoving = false;
				this.isConfirmRemoveVisible = false;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Remove Rundown',
					text: message,
				});
			};
			const errorCallback = (e) => {
				this.isRemoving = false;
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Remove Rundown',
					text: message,
				});
			};
			rundownsApi.delete(item.id, callback, errorCallback);
		},

		confirmEdit(item) {
			this.rundownName = item.name;
			let formatDate = null;
			formatDate = dayjs.utc(item.start_time).format('YYYY-MM-DD HH:mm');
			this.dateTime = formatDate;
			const indexStatus = this.filteredStatusList.findIndex(({ key }) => key === item.status);
			if (indexStatus !== -1) {
				this.status = this.filteredStatusList[indexStatus];
			} else {
				this.status = { key: 'pre_production', label: 'Pre Production' };
			}
			this.description = item.description;
			this.selectedRundown = item;
			this.isEditVisible = true;
		},

		updateRundown(item) {
			this.isSavingRundown = true;
			const callback = (response) => {
				const itemRundown = response.data;
				const startHour = dayjs.utc(itemRundown.start_time).format('HH:mm');
				const dateTime = dayjs.utc(itemRundown.start_time).format('YYYY-MM-DD');
				const newEndTime = dayjs.utc(itemRundown.start_time).add(1, 'hour').format('HH:mm');
				const index = this.items.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					const newItem = {
						start: `${dateTime} ${startHour}`,
						end: `${dateTime} ${newEndTime}`,
						// message: element.message,
						title: `<div style="font-size: 13px; font-weight: 400; max-width: 200px; white-space: nowrap; overflow: hidden; overflow: hidden; text-overflow: ellipsis;"> ${itemRundown.name} </div>`,
						id: itemRundown.id,
						additional: itemRundown,
						status: itemRundown.status,
					};
					if (itemRundown.status === 'pre_production') newItem.class = 'event-pre_production';
					if (itemRundown.status === 'production') newItem.class = 'event-production';
					if (itemRundown.status === 'post_production') newItem.class = 'event-post_production';
					if (itemRundown.status === 'archive') newItem.class = 'event-archive';
					this.$set(this.items, index, newItem);
				}
				const indexDayDetail = this.modalDetailEvent.findIndex(({ id }) => id === item.id);
				if (index !== -1) {
					const newItem = {
						start: `${dateTime} ${startHour}`,
						end: `${dateTime} ${newEndTime}`,
						// message: element.message,
						title: `<div style="font-size: 13px; font-weight: 400; max-width: 200px; white-space: nowrap; overflow: hidden; overflow: hidden; text-overflow: ellipsis;"> ${itemRundown.name} </div>`,
						id: itemRundown.id,
						additional: itemRundown,
						status: itemRundown.status,
					};
					if (itemRundown.status === 'pre_production') newItem.class = 'event-pre_production';
					if (itemRundown.status === 'production') newItem.class = 'event-production';
					if (itemRundown.status === 'post_production') newItem.class = 'event-post_production';
					if (itemRundown.status === 'archive') newItem.class = 'event-archive';

					this.$set(this.modalDetailEvent, indexDayDetail, newItem);

					const previousDate = dayjs.utc(item.start_time).format('YYYY-MM-DD');
					if (!previousDate.includes(dateTime)) {
						this.modalDetailEvent.splice(indexDayDetail, 1);
						if (this.modalDetailEvent && this.modalDetailEvent.length === 0) this.isShowModalDetail = false;
					}
				}

				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Rundown has been updated',
					text: 'Rundown has been updated',
				});
				this.isSavingRundown = false;
				this.isEditVisible = false;
			};
			const errorCallback = () => {
				this.isSavingRundown = false;
				this.isEditVisible = false;
			};
			const params = {
				name: this.rundownName,
				description: this.description,
				status: this.status,
				start_time: this.dateTime,
			};
			if (this.status && this.status.key) params.status = this.status.key;
			rundownsApi.update(item.id, params, callback, errorCallback);
		},

		showModalName(str) {
			return elpisisString(str);
		},

		notBeforeToday(date) {
			return date < new Date(new Date().setHours(0, 0, 0, 0));
		},

		confirmSharedFolderItem(item) {
			this.selectedRundown = item;
			this.isConfirmSharedFolderVisible = true;
		},

		sharingMisc(id) {
			this.isSharing = true;
			const callback = (response) => {
				const item = response.data;
				this.$notify({
					group: 'app',
					type: 'success',
					title: 'Add Media',
					text: response.message,
				});
				copyToClipboard(item);
				this.isSharing = false;
				this.isConfirmSharedFolderVisible = false;
				this.selectedRundown = null;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Add Media',
					text: message,
				});
				this.isConfirmSharedFolderVisible = false;
			};
			mediasApi.generateUrl(id, callback, errorCallback);
		},

		goToRundown(item) {
			this.$router.push(`/rundowns/editor/${btoa(item.slug)}`);
		},

		getDateUtc(date) {
			return dayjs.utc(date).format('DD/MM/YYYY HH:mm');
		},
	},
	computed: {
		selectedTotalAsset() {
			const total = this.selectedRundown && this.selectedRundown.__meta__ ? this.selectedRundown.__meta__.rundownItems_count : 0;
			return total;
		},
		filteredStatusList() {
			const status = duplicateVar(this.statusList);
			const newArray = status.slice();
			newArray.shift();
			return newArray;
		},
	},
	watch: {
		activeView() {
			if (this.activeView === 'year') {
				this.selectedDate = new Date();
			}
		},
	},
};
</script>
<style>
.vuecal .vuecal__cell--today {
	/* background-color: #FFA800!important; */
}
</style>
